"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.OffersFilter = void 0;
var _offersFilter = _interopRequireDefault(require("./offers-filter"));
exports.OffersFilter = _offersFilter["default"];